<div class="home-page">

    <section style="height: fit-content">
        <app-home-slider></app-home-slider>
    </section>
    <section>
        <app-abstract></app-abstract>
    </section>
    <section *ngIf="activeItem['brands']">
        <app-brand-logos></app-brand-logos>
    </section>
    <section *ngIf="activeItem['SuccessStories']">
        <app-success-story [title]="success_stories['title']"  ></app-success-story>
    </section>
    <section *ngIf="activeItem['ServiceFeatures']">
        <app-feature-section [title]="service_features['title']"></app-feature-section>
    </section>
    <section>
        <app-developers-help></app-developers-help>
    </section>
<!--    <section>-->
<!--        <app-performance-section></app-performance-section>-->
<!--    </section>-->

</div>
